const CheckBox = ({ defaultIcon, checkedIcon, onChange, checked }) => {
  return (
    <span onClick={() => onChange(!checked)} className="cp">
      {checked ? checkedIcon : defaultIcon}
    </span>
  );
};

export default CheckBox;
